/* eslint-disable no-unused-vars */
import { ReactNode, RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { useLenis } from '@/contexts/lenis'
import { isTouch } from '@/utils/device'
import { MediaQuery } from '@/constants'

import { Animation } from '@/types'

type MotionProps = {
  children: (ref: RefObject<HTMLDivElement>) => ReactNode
  animation: (props: Animation<HTMLElement>) => (() => void) | void // gsap.core.Timeline
  nodeRef?: RefObject<HTMLElement>
  revertOnUpdate?: boolean
}

const Motion = ({
  nodeRef,
  children,
  animation,
  revertOnUpdate = true
}: MotionProps) => {
  const root = useRef<HTMLDivElement>(null!)
  const { lenis } = useLenis()

  useGSAP(
    (context) => {
      if (!lenis) return

      const matchMedia = gsap.matchMedia(root.current)

      matchMedia.add(
        {
          isSmall: MediaQuery.SMALL,
          isLarge: MediaQuery.LARGE
        },
        ({ conditions }) => {
          const revert = animation({
            node: root.current,
            reverse: true,
            conditions,
            nodeRef,
            context
          })

          return () => {
            if (revert) {
              revert()
            }
          }
        }
      )

      return () => {
        matchMedia.revert()
      }
    },
    {
      dependencies: [lenis],
      scope: nodeRef || root,
      revertOnUpdate
    }
  )

  return children(root)
}

export default Motion
